import React, { useEffect, useState, forwardRef } from "react";
import { useHistory } from "react-router-dom";

import clsx from "clsx";
import {
  Button,
  Form,
  OverlayTrigger,
  Popover,
  Tooltip,
} from "react-bootstrap";

import iconChat from "../../../assets/images/chat-icon.png";
import Chat from "../../../assets/images/chat.png";

import CritereImpactantHover from "../../../assets/images/critere-impactant-hover.png";
import CritereImpactantSelected from "../../../assets/images/critere-impactant-selected.png";
import CritereImpactantNonSelected from "../../../assets/images/critere-impactant-non-selected.png";

import PointsDragDrop from "../../../assets/images/points-drag-drop.png";
import ArrowDown from "../../../assets/images/arrow-down-.png";
import ArrowUpSelected from "../../../assets/images/arrow-up-selected.png";
import PenSelected from "../../../assets/images/selected-pen.png";
import CheckCerclePrimary from "../../../assets/images/check-circle-primary.png";
import Trash from "../../../assets/images/trash.png";

import iconMalusRed from "../../../assets/images/icon-malus-red.png";
import iconMalus from "../../../assets/images/icon-malus.png";

import iconBonusGreen from "../../../assets/images/icon-bonus-green.png";
import iconBonus from "../../../assets/images/icon-bonus.png";

import iconAddBonusMalusColor from "../../../assets/images/add-bonus-malus-icon-color.png";

import paintBrush from "../../../assets/images/paint-brush.png";
import blockedBrush from "../../../assets/images/blocked.png";
import checkCircleWhite from "../../../assets/images/check-circle-white.png";

import "./addGrille.css";
import CriteriaValue from "./criteriaValue";
import CriteriaOption from "./criteriaOption";
import { useDispatch } from "react-redux";
import { removeCriteriaValues } from "../../../redux/actions/grille";

const paletteDeCouleur = [
  "#FCE5E5",
  "#E30707",
  "#FEA729",
  "#FFD800",
  "#E7F6E7",
  "#1CA91B",
];

const Critere = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [selectedCritereImpact, setSelectedCritereImpact] = useState(false);
  const [hoveredCritereImpact, setHovredCritereImpact] = useState(false);
  const [valeursAtt, setValeursAtt] = useState(
    props.criteres?.filter((e) => e.id === props.idCriteria)[0]?.CriteriaValue
  );

  const [isSelectionNeutre, setIsSelectionNeutre] = useState(false);
  const [isSelectionBonus, setIsSelectionBonus] = useState(false);
  const [isSelectionMalus, setIsSelectionMalus] = useState(false);
  const [addedDetailsBonus, setAddedDetailsBonus] = useState(false);

  const [openCritere, setOpenCritere] = useState(false);
  const [editNameCritere, setEditNameCritere] = useState(false);
  const [isOpenComment, setIsOpenComment] = useState(false);

  const [score, setScore] = useState(10);
  const [selectedPing, setSelectedPing] = useState(false);
  const [hoverPing, setHoverPing] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [hoverPalette, setHoverPalette] = useState(false);
  const [colorCriteriaValue, setColorCriteriaValue] = useState("#5800E2");



  const addClick = () => {
    const data = {
      id: valeursAtt.length + 1,
      name: ``,
      color: " rgb(88,0,226)",
      backGroundColor: "rgba(88,0,226, 0.1)",
    };
    if (valeursAtt.length < 5) {
      setValeursAtt([...valeursAtt, data]);
    }
  };

  const removeClick = (i) => {
    setValeursAtt(valeursAtt.filter(({ id }) => id !== i));
    dispatch(removeCriteriaValues(i));
    props.handelDeleteCriteriaValue(props.idGroupCriteria, props.idCriteria, i);
    props.groupeCritere
      ?.filter((e) => e.id === props.idGroupCriteria)[0]
      ?.Criteria.filter((e) => e.id === props.idCriteria)[0]
      ?.CriteriaValue.filter(({ id }) => id !== i);

  };

  const selectValue = (value) => {
    setOpenCritere(true);
    setSelectedValue(value);
  };

  const tooltipPalette = () => {
    setHoverPalette(!hoverPalette);
  };

  const popover = (
    <Tooltip id="tooltip-bottom-input" style={{ opacity: 1 }}>
      <Form.Control
        className="textarea-comment"
        as="textarea"
        defaultValue={
          props.groupeCritere
            ?.filter((e) => e.id === props.idGroupCriteria)[0]
            ?.Criteria.filter((e) => e.id === props.idCriteria)[0]?.description
        }
        onChange={(e) =>
          props.handelchangeDescriptionCritere(
            e.target.value,
            props.idGroupCriteria,
            props.idCriteria
          )
        }
        rows={3}
      />
    </Tooltip>
  );

  return (
    <>
      <div className={clsx({ "critere-bar": true }, { height: openCritere })}>
        <div className="container-drag-drop-critere">
          <img src={PointsDragDrop} />
        </div>
        <div style={{ height: "100%", width: "100%" }}>
          <div className="first-row-under-critere">
            <div className="container-bar-critere-section-1">
              <div style={{ marginLeft: 10, marginRight: -35 }}>
                <input
                  className={clsx(
                    { "container-input": true },
                    { "container-input-disabled": !editNameCritere }
                  )}
                  placeholder="Critère"
                  defaultValue={
                    props?.criteres.filter((e) => e.id === props.idCriteria)[0]
                      ?.name
                  }
                  type="text"
                  onChange={(e) =>
                    props.handelChangeCriteriaName(
                      e.target.value,
                      props.idGroupCriteria,
                      props.idCriteria
                    )
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setEditNameCritere(!editNameCritere);
                    }
                  }}
                  onFocus={() => {
                    setEditNameCritere(!editNameCritere);
                  }}
                />
                <div
                  className={clsx(
                    { "btn-inside": true },
                    { "container-icons-groupe-critere": editNameCritere },
                    {
                      "container-icons-groupe-critere-selected":
                        !editNameCritere,
                    }
                  )}
                  onClick={() => {
                    setEditNameCritere(!editNameCritere);
                  }}
                >
                  {editNameCritere ? (
                    <img src={CheckCerclePrimary} height={15} />
                  ) : (
                    <img src={PenSelected} height={15} />
                  )}
                </div>
              </div>
              <div
                style={{ cursor: "pointer", paddingLeft: 30 }}
                onMouseEnter={() => setHovredCritereImpact(true)}
                onMouseLeave={() => setHovredCritereImpact(false)}
              >
                {hoveredCritereImpact &&
                  !props?.groupeCritere
                    .filter((e) => e.id === props.idGroupCriteria)[0]
                    .Criteria?.filter((e) => e.id === props.idCriteria)[0]
                    ?.impact ? (
                  <OverlayTrigger
                    key="bottom"
                    placement="bottom"
                    overlay={
                      <Tooltip
                        data-color="#5800e2"
                        className="critere"
                        id={`tooltip-bottom`}
                      >
                        Critere impactant
                      </Tooltip>
                    }
                  >
                    <img
                      src={CritereImpactantHover}
                      height={30}
                      onClick={() => {
                        props.handelchangeCritereImpactant(
                          !props?.groupeCritere
                            .filter((e) => e.id === props.idGroupCriteria)[0]
                            .Criteria?.filter(
                              (e) => e.id === props.idCriteria
                            )[0]?.impact,
                          props.idGroupCriteria,
                          props.idCriteria
                        );
                      }}
                    />
                  </OverlayTrigger>
                ) : (
                  <div>
                    {props?.groupeCritere
                      .filter((e) => e.id === props.idGroupCriteria)[0]
                      .Criteria?.filter((e) => e.id === props.idCriteria)[0]
                      ?.impact ? (
                      <img
                        src={CritereImpactantSelected}
                        height={30}
                        onClick={() => {
                          props.handelchangeCritereImpactant(
                            !props?.groupeCritere
                              .filter((e) => e.id === props.idGroupCriteria)[0]
                              .Criteria?.filter(
                                (e) => e.id === props.idCriteria
                              )[0]?.impact,
                            props.idGroupCriteria,
                            props.idCriteria
                          );
                        }}
                      />
                    ) : (
                      <img src={CritereImpactantNonSelected} height={30} />
                    )}
                  </div>
                )}
              </div>

              {
                props?.groupeCritere.filter((e) => e.id === props.idGroupCriteria)[0].Criteria?.filter((e) => e.id === props.idCriteria)[0]?.impact
                  ?
                  (<OverlayTrigger
                    key="bottom"
                    placement="bottom"
                    style={{}}
                    overlay={
                      <Tooltip
                        data-color="#5800e2"
                        className="critere"
                        id={`tooltip-bottom`}
                      >
                        Coefficient
                      </Tooltip>
                    }
                  >
                    <Form.Control
                      style={{
                        border: "dashed 1px",
                        borderColor: "#CCB2F5 !important",
                        backgroundColor: "rgba(183, 183, 183, 0.1)",
                        width: "40px",
                        padding: "5px",
                        top: 0,
                      }}
                      placeholder="1"
                      min="1"
                      max="10"
                      type="number"
                      tabIndex="0"
                      defaultValue={
                        props?.groupeCritere
                          .filter((e) => e.id === props.idGroupCriteria)[0]
                          ?.Criteria.filter((e) => e.id === props.idCriteria)[0]
                          ?.coefficient
                      }
                      onChange={(e) =>
                        props.handelChangeCriteriaCoefficient(
                          e.target.value,
                          props.idGroupCriteria,
                          props.idCriteria
                        )
                      }
                    />
                  </OverlayTrigger>
                  ) : (<OverlayTrigger
                    key="bottom"
                    placement="bottom"
                    overlay={
                      <Tooltip
                        data-color="#5800e2"
                        className="critere"
                        id={`tooltip-bottom`}
                      >
                        Coefficient
                      </Tooltip>
                    }
                  >
                    <Form.Group
                      style={{
                        border: "dashed 1px #CCB2F5",
                        borderRadius: "5px",
                        borderColor: "#CCB2F5 !important",
                        backgroundColor: "rgba(183, 183, 183, 0.1)",
                        width: "40px",
                        height: "40px",
                        padding: "5px",
                        top: 0,
                      }}
                      placeholder="0"
                      min="1"
                      max="10"
                      type="number"
                      tabIndex="0"
                      disabled="true"
                      defaultValue="0"
                    >
                      <Form.Label style={{ color: "#B7B7B7" }}>0</Form.Label>
                    </Form.Group>
                  </OverlayTrigger>)
              }

              {valeursAtt.map((value, i) => (
                <CriteriaValue
                  key={i}
                  valuesNumber={valeursAtt.length}
                  value={value}
                  removeClick={removeClick}
                  selectValue={selectValue}
                  idGroupCriteria={props.idGroupCriteria}
                  idCriteria={props.idCriteria}
                  handelChangeCriteriaValue={props.handelChangeCriteriaValue}
                />
              ))}
              {valeursAtt.length < 5 ? (
                <div
                  className="add-container"
                  onClick={addClick}
                  style={{ zIndex: 10 }}
                >
                  <img src={iconAddBonusMalusColor} />
                </div>
              ) : null}
            </div>
            <div className="container-bar-critere-section-2">
              <div className="container-icons-critere">
                {isOpenComment ? (
                  <OverlayTrigger
                    trigger="click"
                    rootClose
                    placement="bottom-end"
                    overlay={popover}
                  >
                    <img
                      className="img-chat-position-add-grille"
                      width={15}
                      src={iconChat}
                      onClick={() => setIsOpenComment(false)}
                    />
                  </OverlayTrigger>
                ) : (
                  <OverlayTrigger
                    trigger="click"
                    rootClose
                    placement="bottom-end"
                    overlay={popover}
                  >
                    <img
                      className="img-chat-position-add-grille"
                      width={15}
                      src={Chat}
                      onClick={() => setIsOpenComment(true)}
                    />
                  </OverlayTrigger>
                )}
              </div>

              <div
                className="container-icons-critere"
                onClick={() => {
                  props.handelDeleteCriters(
                    props.idGroupCriteria,
                    props.idCriteria
                  );
                }}
              >
                <img width={15} src={Trash} />
              </div>

              <div
                className={clsx(
                  { "container-icons-critere": openCritere },
                  { "container-icons-groupe-critere-selected": !openCritere }
                )}
                onClick={() => {
                  setOpenCritere(!openCritere);
                  setSelectedValue(null);
                }}
              >
                {openCritere ? (
                  <img src={ArrowDown} />
                ) : (
                  <img src={ArrowUpSelected} />
                )}
              </div>
            </div>
          </div>

          {openCritere ? (
            <div className="second-row-under-critere">
              {!selectedValue ? (
                <CriteriaOption
                  groupeCritere={props.groupeCritere}
                  idGroupCriteria={props.idGroupCriteria}
                  idCriteria={props.idCriteria}
                  handelChangeCriteriaOption={props.handelChangeCriteriaOption}
                  handelChangeCriteriaOptionName={
                    props.handelChangeCriteriaOptionName
                  }
                  handelChangeCriteriaOptionScore={
                    props.handelChangeCriteriaOptionScore
                  }
                />
              ) : null}

              {selectedValue ? (
                <>
                  <textarea
                    className="section-description"
                    style={{
                      height: "10vh",
                      //  padding:"20px",
                      borderColor: selectedValue.color,
                    }}
                    placeholder={"description"}
                    value={
                      selectedValue.description
                        ? selectedValue?.description
                        : ""
                    }
                    onChange={(e) =>
                      props.handelChangeValueDescription(
                        e.target.value,
                        props.idGroupCriteria,
                        props.idCriteria,
                        selectedValue.id
                      )
                    }
                  />
                  <div
                    className="button-palette-couleur d-flex justify-content-center align-items-center"
                    onClick={tooltipPalette}
                  >
                    <img src={paintBrush} />
                  </div>

                  <div
                    className={clsx(
                      { "d-none": !hoverPalette },
                      { "d-block": hoverPalette }
                    )}
                  >
                    <Tooltip
                      id="tooltip-palette-couleur"
                      className="d-flex justify-content-center"
                    >
                      <div
                        className="color-cercle d-flex justify-content-center align-items-center"
                        style={{ backgroundColor: "#E0E0E0" }}
                        onClick={() => {
                          setColorCriteriaValue("#5800E2");
                          props.handelChangeValueColor(
                            props.idGroupCriteria,
                            props.idCriteria,
                            selectedValue.id,
                            "#5800E2"
                          );
                        }}
                      >
                        <img width={18} src={blockedBrush} />
                      </div>
                      {paletteDeCouleur.map((color, i) => (
                        <div
                          key={i}
                          className="color-cercle d-flex justify-content-center align-items-center"
                          style={{ backgroundColor: color }}
                          onClick={() => {
                            setColorCriteriaValue(color);
                            props.handelChangeValueColor(
                              props.idGroupCriteria,
                              props.idCriteria,
                              selectedValue.id,
                              color
                            );
                          }}
                        >
                          {color === colorCriteriaValue ? (
                            <img width={18} src={checkCircleWhite} />
                          ) : null}
                        </div>
                      ))}
                    </Tooltip>
                  </div>
                </>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default Critere;
